import { render, staticRenderFns } from "./target-wallet-preview.vue?vue&type=template&id=768e17f4&scoped=true&"
import script from "./target-wallet-preview.vue?vue&type=script&lang=js&"
export * from "./target-wallet-preview.vue?vue&type=script&lang=js&"
import style0 from "./target-wallet-preview.vue?vue&type=style&index=0&id=768e17f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768e17f4",
  null
  
)

export default component.exports